import * as React from 'react'

import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

const ConflictsTooltip = ({ children }: React.PropsWithChildren) => {
  const [{ conflictsCount }] = useSchedule()
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const [tooltipOpen, toggleTooltip] = useToggle()

  /**
   * We show the tooltip only when the button is disabled because of conflicts
   * If the button is disabled because there are no drafts, we don't show it.
   */
  const showTooltip = conflictsCount !== 0 && tooltipOpen
  const conflictsAlertEnabled = hasFeatureFlag('dev_shift_management_conflicts_alert')
  const label = conflictsAlertEnabled
    ? i18n.t('shift_management.publish.disabled_tooltip_conflict', { count: conflictsCount })
    : i18n.t('shift_management.publish.disabled_tooltip')

  return (
    <Tooltip.Alt
      attachment="top center"
      targetAttachment="bottom center"
      open={showTooltip}
      toggle={toggleTooltip}
      label={label}
    >
      {children}
    </Tooltip.Alt>
  )
}

export default ConflictsTooltip
